import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { TournamentService } from '../../../services/tournament.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'me-ko-edit',
  templateUrl: 'me-ko-edit.html',
})
export class EditMeKoPage {

  activePlan: any;
  ti: any;
  results = ["0", "0"];
  points = ["0", "0"];
  roundPhase: boolean = false;
  changeDetector: boolean = false;

  constructor(
    private navParams: NavParams,
    private toastCtrl: ToastController,
    private viewCtrl: ViewController,
    public gs: TournamentService,
    private navCtrl: NavController,
    private translate: TranslateService
  ) {
    console.log(this.navCtrl.getViews());
  }

  ionViewDidLoad() {
    this.activePlan = this.navParams.get('activePlan');
    this.ti = this.navParams.get('teamIndex');
    this.roundPhase = this.navParams.get('roundPhase');
    if (this.ti.graph) {
      this.results = this.gs.planList[this.activePlan].roundGameTable[this.ti.i][this.ti.j].results.split('-');
      this.points = this.gs.planList[this.activePlan].roundGameTable[this.ti.i][this.ti.j].points.split('-')
    } else {
      this.results = this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].results.split('-');
      this.points = this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].points.split('-')
    }
    this.gs.save();
  }

  onChangeTeam(index) {
    this.toastCtrl.create({
      duration: 5000,
      position: 'top',
    }).present();
  }


  onSave() {
    this.gs.save();
  }

  onResultChange(teamIndex: string, value: any) {
    // value = Number(value);
    // if(value >= 0){
    //   let teamId =  this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j][teamIndex].id;
    //   let arrIndex = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === teamId);
    //   this.gs.planList[this.activePlan].teams[arrIndex].results =+ value;
    // }
    let winner = this.getWinner();
    if (winner > -1) this.points[winner] = value + "";
    this.onSetWinner(winner);
  }

  getWinner() {
    if (this.points[0] > this.points[1]) {
      return 0;
    } else if (this.points[0] < this.points[1]) {
      return 1;
    } else {
      return 2;
    }
  }

  onPointsChange(teamIndex: string, value: any) {
    // value = Number(value);
    // if(value >= 0){
    //   let teamId =  this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j][teamIndex].id;
    //   let arrIndex = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === teamId);
    //   this.gs.planList[this.activePlan].teams[arrIndex].points += value;      
    //   let winner = this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team1.points > this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team2.points ? 0 : 1;
    //   if(typeof this.gs.planList[this.activePlan].gameTable[this.ti.i + 1] != "undefined" && this.gs.planList[this.activePlan].roundPhase){
    //     let team = (this.ti.j % 2) ? 'team2' : 'team1';
    //     this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i + 1][Math.floor(this.ti.j / 2)][team].id = this.gs.planList[this.activePlan].teams[arrIndex].id;
    //     this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i + 1][Math.floor(this.ti.j / 2)][team].name = this.gs.planList[this.activePlan].teams[arrIndex].name;
    //   }
    //   this.onSetWinner(winner);
    // }
    // let teamId = this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j][teamIndex].id;
    // let arrIndex = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === teamId);
    let team = (teamIndex.includes('team1')) ? 0 : 1;
    this.points[team] = value + "";
    let winner = this.getWinner();
    // if(winner > -1 && winner < 2) this.points[winner] = value + "";
    // this.assignNextTeam(arrIndex);
    this.onSetWinner(winner);
  }

  teamClick(winnerIndex: number) {
    // let team = (winnerIndex % 2) ? 'team2' : 'team1';
    // this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j][team].results = this.gs.counters.winScore;
    // let teamId =  this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j][team].id;
    // let arrIndex = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === teamId);
    // this.gs.planList[this.activePlan].teams[arrIndex].points += this.gs.counters.winScore; 
    // this.onSetWinner(winnerIndex);
    // let team = (winnerIndex % 2) ? 'team2' : 'team1';
    // let teamId = this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j][team].id;
    // let arrIndex = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === teamId);
    this.points[winnerIndex] = this.gs.counters.winScore + "";
    // this.assignNextTeam(arrIndex);
    this.onSetWinner(winnerIndex);
  }

  onSetWinner(winnerIndex: number) {
    this.gs.planList[this.activePlan].gameTable[0][this.ti.i][this.ti.j].played = true;
    this.gs.planList[this.activePlan].gameTable[0][this.ti.i][this.ti.j].winner = winnerIndex;
    this.changeDetector = true;
    this.gs.save();
  }

  checkCompletion() {
    for (let r = 0; r < this.gs.planList[this.activePlan].gameTable.length; r++)
      for (let i = 0; i < this.gs.planList[this.activePlan].gameTable[r].length; i++) {
        for (let j = 0; j < this.gs.planList[this.activePlan].gameTable[r][i].length; j++) {
          this.gs.planList[this.activePlan].roundPhase = this.gs.planList[this.activePlan].gameTable[r][i][j].played;
        }
      }
  }

  async assignNextTeam(arrIndex: number) {
    if (typeof this.gs.planList[this.activePlan].gameTable[this.ti.i + 1] != "undefined") {
      let team = (this.ti.j % 2) ? 'team2' : 'team1';
      if (!this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i + 1][Math.floor(this.ti.j / 2)][team]) {
        this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i + 1][Math.floor(this.ti.j / 2)][team] = this.gs.planList[this.activePlan].teams[arrIndex];
      }
    }
  }

  update() {
    if (this.ti.graph) {
      this.gs.planList[this.activePlan].roundGameTable[this.ti.i][this.ti.j].team1.points += Number(this.points[0]);
      this.gs.planList[this.activePlan].roundGameTable[this.ti.i][this.ti.j].team2.points += Number(this.points[1]);;
      this.gs.planList[this.activePlan].roundGameTable[this.ti.i][this.ti.j].team1.results += Number(this.results[0]);
      this.gs.planList[this.activePlan].roundGameTable[this.ti.i][this.ti.j].team2.results += Number(this.results[1]);
      this.gs.planList[this.activePlan].roundGameTable[this.ti.i][this.ti.j].points = this.points[0] + "-" + this.points[1];
      this.gs.planList[this.activePlan].roundGameTable[this.ti.i][this.ti.j].results = this.results[0] + "-" + this.results[1];
      let team1Id = this.gs.planList[this.activePlan].roundGameTable[this.ti.i][this.ti.j].team1.id;
      let team2Id = this.gs.planList[this.activePlan].roundGameTable[this.ti.i][this.ti.j].team2.id;
      let arr1Index = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === team1Id);
      let arr2Index = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === team2Id);
      this.gs.planList[this.activePlan].teams[arr1Index].points += Number(this.points[0]);
      this.gs.planList[this.activePlan].teams[arr2Index].points += Number(this.points[1]);
      this.gs.planList[this.activePlan].teams[arr1Index].results += Number(this.results[0]);
      this.gs.planList[this.activePlan].teams[arr2Index].results += Number(this.results[1]);
    } else {
      this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team1.points += Number(this.points[0]);
      // this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team2.points += Number(this.points[1]);;
      this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team1.results += Number(this.results[0]);
      // this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team2.results += Number(this.results[1]);
      this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].points = this.points[0] + "-" + this.points[1];
      this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].results = this.results[0] + "-" + this.results[1];
      // this.gs.saveTeam(this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team1);
      // this.gs.saveTeam(this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team2);
      let team1Id = this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team1.id;
      // let team2Id = this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team2.id;
      let arr1Index = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === team1Id);
      // let arr2Index = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === team2Id);
      let team2Id;
      let arr2Index=-1;
      if( this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team2){
        this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team2.points += Number(this.points[1]);;
        this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team2.results += Number(this.results[1]);
        team2Id = this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i][this.ti.j].team2.id;
        arr2Index = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === team2Id);
      }
      if(arr1Index>-1 && arr2Index>-1){
        this.gs.planList[this.activePlan].teams[arr1Index].points += Number(this.points[0]);
        this.gs.planList[this.activePlan].teams[arr2Index].points += Number(this.points[1]);
        this.gs.planList[this.activePlan].teams[arr1Index].results += Number(this.results[0]);
        this.gs.planList[this.activePlan].teams[arr2Index].results += Number(this.results[1]);
      }
    }
    this.gs.save();
    this.gs.saveTou(this.gs.planList[this.activePlan]).then(plan => {
      this.gs.planList[this.activePlan] = plan;
    });
  }

  onClose() {
    const team1 = this.gs.planList[this.activePlan]?.roundGameTable[this.ti.i][this.ti.j]?.team1?.name;
    const team2 = this.gs.planList[this.activePlan]?.roundGameTable[this.ti.i][this.ti.j]?.team2?.name;

    if (!team1 || !team2) {
        console.log("Team name is missing. Please select a team before closing.");
        this.showMessage(this.translate.instant("MESSAGE_TEAM_NAME_IS_MISSING"));
        return;
    }
    if (this.changeDetector) this.update();
    this.viewCtrl.dismiss();
  }
  showMessage(message: string) {
    this.toastCtrl.create({
      message: message,
      position: 'top',
      duration: 3000
    }).present();
  }
}







// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/edits/me-ko/me-ko-edit.ts